import { Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import type { LandingPageV2Props } from 'cms';
import { LandingPageSectionContainer } from 'components/landing-pages-v2/shared/Container';
import type { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import type { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';

import LandingPageV2Layout, { getLandingpageV2ServerSideProps } from './shared/LandingPageV2Layout';

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => {
  //Manually setting the slug to fetch the landing Page( with only header and footer) from Contentful.
  context.params = {
    slug: 'error',
  };

  context.query.slug = 'error';
  return getLandingpageV2ServerSideProps(context);
};
export default withRouter(
  (context: React.PropsWithChildren<WithRouterProps> & LandingPageV2Props) => {
    return (
      <LandingPageV2Layout {...context}>
        <RenderErrorPage />
      </LandingPageV2Layout>
    );
  },
);
const RenderErrorPage = () => {
  return (
    <LandingPageSectionContainer
      $largerThanSM={{ width: '40%' }}
      marginTop="$24x"
      justifyContent="space-between"
      marginBottom="15%"
    >
      <Col>
        <Col className="pb-8">
          <Text as="h2" className="text-subheader-lg pb-2">
            Something went wrong
          </Text>
          <Text as="h2" className="text-body-md">
            It looks like we ran into an issue while learning about your home. Try again, or start
            over by returning to the homepage.
          </Text>
        </Col>
        <Col className="pb-10 gap-2">
          <Button
            onClick={(e) => {
              e.stopPropagation();
              document.location.href = document.referrer;
            }}
            analyticsName="cosmos-error-try-again-button"
            aria-label="Try again"
            variant="primary"
            size="lg"
          >
            Try again
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              document.location.href = 'https://www.opendoor.com';
            }}
            analyticsName="cosmos-error-return-to-homepage-button"
            aria-label="Return to homepage"
            variant="secondary"
            size="lg"
          >
            Return to homepage
          </Button>
        </Col>
        <Row className="items-center flex-wrap gap-1">
          <Text as="span" className="text-body-sm">
            Contact us at
          </Text>
          <Link
            aria-label={`opendoor-error-contact-email`}
            href={'mailto:support@opendoor.com'}
            analyticsName={`cosmos-error-page-contact-support`}
            className="text-od-content-primary"
          >
            support@opendoor.com
          </Link>
          <Text as="span" className="text-body-sm">
            or
          </Text>
          <Link
            aria-label={`opendoor-error-contact-email`}
            href={'tel:888-352-7075'}
            analyticsName={`cosmos-error-page-contact-support`}
            className="text-od-content-primary"
          >
            888-352-7075
          </Link>
          <Text as="span" className="text-body-sm">
            if this happens again.
          </Text>
        </Row>
      </Col>
    </LandingPageSectionContainer>
  );
};
